<template>
	<div class="page">
		<div class="searchBox" style="display: none;">
		</div>
		<div class="pageConBox">
			<div class="navBox">
				<div style="font-size: 18px;color:#333336;padding:4px 6px 8px;">分类选择</div>
				<el-button size="mini" style="width:100%;margin: 6px 0;" @click="addTag('')">添加</el-button>
				<el-tree :data="tagTree" :highlight-current='true' :node-key="'key'" :props="{children:'symptom',label:'value'}" default-expand-all :expand-on-click-node="false" :render-content="renderContent" @node-click ='handleNodeClick'>
				</el-tree>
			</div>
			<div class="tableBox" ref="tableBox">
				<div style="font-size: 18px;color:#333336;padding:13px 16px 8px;">病因分类</div>
				<el-table :data="list" style="width: 100%" ref = 'table1' row-class-name="row-expand-cove">
					<el-table-column prop="title" label="症状" :key="Math.random()">
						<template slot-scope="scope">
							<span v-for="(item,index) in scope.row.parent_all" :key="index">
								{{item.name}} - 
							</span>
							{{scope.row.name}}
						</template>
					</el-table-column>
				<!-- 	<el-table-column label="操作人" >
						<template slot-scope="scope">
							{{scope.row.name}}
						</template>
					</el-table-column> -->
					<el-table-column label="关联药品数量">
						<template slot-scope="scope">
							{{scope.row.num}}
						</template>
					</el-table-column>
					<el-table-column label="操作" >
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="toEdit(scope.row)">关联药品</el-button>
							<el-button type="text" size="mini" @click="toDel(scope.row)">删除该标签</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div v-if="dialogSetTag_state">
			<dialogSetTag :tagItem="curTag" @submit="submit_dialogSetTag"></dialogSetTag>
		</div>
	</div>
</template>
<script>
	import dialogSetTag from "./dialog_setTag.vue"
	export default {
		components: {dialogSetTag},
		data() {
			return {
				params:{
					keyword:'',
				},
				tagTree:[],
				curTagId:'',
				
				list:[],
				
				// 添加标签
				dialogSetTag_state:false,
				curTag:{},
			}
		},
		computed: {
			curShopId() {
				return this.$store.state.shopId;
			},
		},
		beforeRouteEnter(to,from,next){
			if(from.path==='/yiliaoxin/tagAdd'){
				next(vm=>{
					vm.getChildrenTag()
				})
			}else{
				next()
			}
		},
		mounted() {
			this.getMedicineTag()
		},
		methods: {
			toEdit(row){
				sessionStorage.setItem("midicineSecondTag",JSON.stringify(row))
				this.$router.push({path:'/yiliaoxin/tagAdd'})
			},
			toDel(row){
				this.$confirm('该操作将删除该标签下的所有药品，确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"id": row.id,
					}
					let loading = this.$loading()
					this.$http.delete(process.env.VUE_APP_Url_baseData+'/api/tag/medicine', params).then(res => {
						loading.close()
						if(res.code===0){
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getMedicineTag()
						}
					})
				})
			},
			handleNodeClick(e){
				this.curTagId = e.id
				this.getChildrenTag()
			},
			// 医疗标签
			addTag(data){
				this.curTag = data
				this.dialogSetTag_state = true;
			},
			submit_dialogSetTag(obj){
				this.dialogSetTag_state = false;
				if(obj.type==='success'){
					this.getMedicineTag();
				}
			},
			getMedicineTag(){
				this.$http.get(process.env.VUE_APP_Url_baseData+'/api/tag/medicine/tree', {}).then(res => {
					let tree = []
					for(let i=0;i<res.data.length;i++){
						let l1 = {
							id:res.data[i].id,
							key:res.data[i].code,
							value:res.data[i].label,
							symptom:[],
							children:[],
						}
						for(let a=0;a<res.data[i].children.length;a++){
							l1.symptom.push({
								id:res.data[i].children[a].id,
								key:res.data[i].children[a].code,
								value:res.data[i].children[a].label,
								children:res.data[i].children[a].children,
							})
							l1.children.push({
								id:res.data[i].children[a].id,
								key:res.data[i].children[a].code,
								value:res.data[i].children[a].label,
								children:res.data[i].children[a].children,
							})
						}
						tree.push(l1)
					}
					this.tagTree = tree;
					if(this.curTagId===''){
						this.curTagId = tree[0].id
					}
					this.getChildrenTag()
				})
			},
			getChildrenTag(){
				let params = {
					id:this.curTagId,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_baseData+'/api/tag/medicine/subData', params).then(res => {
					loading.close()
					if(res.code===0){
						let list = []
						let arr = []
						for(let i=0;i<res.data.length;i++){
							if(res.data[i].level===3){
								list.push(res.data[i])
								arr.push(res.data[i].custom_code)
							}
						}
						this.$http.post(process.env.VUE_APP_Url_baseData+'/api/product/medical/tagrelevanceMedicalList', arr).then(res1 => {
							for(let i=0;i<res1.data.length;i++){
								list[i].num = res1.data[i].num
							}
							this.list = list
						})
					}
				})
			},
			renderContent(h, { node, data}) {
				return (
				<span class="custom-tree-node">
				<span>{node.label}</span>
				<span class='custom-tree-btn'>
				<el-button size="mini"  type="text" icon = 'el-icon-plus' on-click={ () => this.addTag(data) }></el-button>
				<el-button size="mini"  type="text" icon = 'el-icon-delete' on-click={ () => this.toDel(data) }></el-button>
				</span>
				</span>
				)   
			},
		}
	}
</script>
<style  lang="scss" scoped="scoped">
	.page {
		height: 100%;
		.searchBox {
			.el-form-item {
				margin-bottom: 0;
			}
		}
		.tabLine {
			margin-top: 12px;
			display: flex;
			
			.tabItem {
				padding: 0 16px;
				line-height: 36px;
				text-align: center;
				border-right: 1px solid #F2F2F2;
				cursor: pointer;
				font-size: 14px;
				background-color: #fff;
				&.active {
					color: $mainColor;
				}
			}
		}

		.pageConBox {
			display: flex;
			border-top:1px solid #F2F2F2;
			height: calc(100% - 115px);
			background-color: transparent;
			.navBox{
				width:190px;
				padding:10px;
				height: 100%;
				border-radius: 6px;
				background-color: #fff;
				margin-right: 13px;
				overflow: auto;
				box-sizing: border-box;
				border-radius: 12px;
				flex-shrink: 0;
				.navItem{
					line-height: 40px;
					padding-left:20px;
					cursor: pointer;
					.active{
						color:#1890FF
					}
				}
				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}
				::v-deep .custom-tree-node{
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 12px;
					padding-right: 8px;
				}
				::v-deep .custom-tree-btn{
					display: none;
				}
				::v-deep .custom-tree-node:hover .custom-tree-btn{
					display: block;
				}
			}
		}
		.tableBox{
			width:calc(100% - 160px);
			height: 100%;
			overflow: auto;
			border-radius: 12px;
			background-color: #fff;
		}
		
		.el-table__expand-icon{
			height:0;
		
		}
		
	}
	
	
</style>
